/**
 * Generates a pseudorandom integer between 0 and `max`.
 * @param max Maximum value for the noise.
 */
export default function intNoise(max: number): number {
  return Math.round(Math.random() * max);
}
